import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=64892ea0&"
import script from "./Flow.vue?vue&type=script&lang=ts&"
export * from "./Flow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports